<script setup>
import WizardLayout from '@/Layouts/WizardLayout.vue';
import FormButton from '@/components/Shared/Form/Button.vue';
import {computed, inject, onBeforeMount, provide} from 'vue';
import {useForm} from '@inertiajs/vue3';
import ConfigureFlow from '@/components/Dashboard/ConfigureFlow.vue';
import TwoIntegrations from '@/components/Dashboard/TwoIntegrations.vue';

onBeforeMount(() => {
  provide('currentStep', 3);
});

const trans = inject('trans')

const props = defineProps({
  integration: {
    type: Object,
    required: true,
  },
  application1: {
    type: Object,
    required: true,
  },
  application2: {
    type: Object,
    required: true,
  },
});

const form = useForm({
  integration: props.integration?.id,
  flows: [],
});

const twoApplicationsHasManualLinks = computed(
  () => getManualLink(props.application1) != null && getManualLink(props.application2) != null,
);

const disabledButton = computed(() => {
  return form.flows.length < 1;
});

const getManualLink = application => {
  return application?.application?.manual_link;
};

const handleSelectedFlows = flows => (form.flows = flows);

const submit = () => {
  form.post(route('wizard.step-3.store'));
};

const getApplicationName = app => {
  return app.placeholderApplication?.display_name || app.application.name;
};

const getManualDescription = computed(() => {
  if (twoApplicationsHasManualLinks.value) {
    return trans('dashboard.integrations.wizard.third_step.manual_description_double', {
      link1: getManualLink(props.application1),
      name1: getApplicationName(props.application1),
      link2: getManualLink(props.application2),
      name2: getApplicationName(props.application2)
    })
  }

  return trans('dashboard.integrations.wizard.third_step.manual_description_single', {
    link: getManualLink(props.application1) || getManualLink(props.application2),
    name: getApplicationName(props.application1) || getApplicationName(props.application2)
  })
})
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <wizard-layout>
    <template #default>
      <div class="wizard_grid">
        <div v-if="integration">
          <div class="form_row">
            <div>
              <h3 class="color_theme pb-2 flex items-center">
                {{ trans('dashboard.integrations.wizard.step_x', {step: 3}) }}
                <span class="color_normal text-xl ml-3">{{ trans('dashboard.integrations.wizard.third_step.title') }}</span>
              </h3>
              <strong class="font-italic">{{ trans('dashboard.integrations.wizard.third_step.description') }}</strong>
            </div>
            <two-integrations :integration1="application1" :integration2="application2" :simple="true"/>
          </div>
          <div
            v-if="getManualLink(application1) != null || getManualLink(application2) != null"
            class="font-light mx-2 my-4"
            v-html="getManualDescription"
          />
          <configure-flow
            :integrationIdProp="integration.id"
            :is-from-wizard="true"
            @selected-flows="handleSelectedFlows"
            :user-id-prop="$page.props.user.id"
          />
        </div>
      </div>
    </template>
    <template #actions>
      <div class="grid-2 mt-2 relative z-10">
        <inertia-link
          class="button button_prev"
          :href="route('wizard.step-2.index')"
          v-text="trans('pagination.previous')"
        />
        <form-button
          :button-class="['button', disabledButton ? 'btn-disabled' : '']"
          @click="submit"
          :value="trans('pagination.next')"
          :processing="form.processing"
          :disabled="disabledButton"
        />
      </div>
    </template>
  </wizard-layout>
</template>
